export const translations = {
    en: {
        headerTitle: "DEVRİMCİSÖZLÜk.",
        headerSubtitle: "To the value of our word...",
        searchPlaceholder: "Type a word...",
        searchButton: "SEARCH",
        palette: "Palette",
        downloadCard: "DOWNLOAD CARD",
        shareCard: "SHARE CARD",
        welcomeTitle: "Welcome!",
        welcomeText: "Use the search button in the navbar to find words, or browse the recent additions below.",
        errorTitle: "Error",
        errorSuffix: ". Try another word.",
        noWords: "No words yet...",
        loadMore: "Load More",
        footerText: "Rights belong to the working class.",

        // WordCard specific
        dictionaryEntry: "Word Card",
        seeAlsoLabel: "See Also",
        sourceLabel: "SOURCE",
        sourceValue: "WORKING CLASS",
        footerBrand: "DevrİmcİSözlük.",

        // Alerts
        noAudio: "No audio pronunciation available for this word.",
        downloadFailed: "Download failed.",
        imageGenNotReady: "Image generator not ready.",
        imageGenFailed: "Image generation failed. Please try again.",
        playPronunciation: "Play pronunciation",

        // Navbar
        login: "Enter Word!",
        logout: "Logout",
        addWord: "Add Word",
        suggest: "Suggest",
        profile: "Profile",
        manage: "Manage",
        navSearch: "Search",
        random: "Random",
        searchTitle: "SEARCH WORD",

        // Login Modal
        loginWelcome: "Welcome Back",
        signupWelcome: "Join the Club",
        loginDesc: "Login to enter a word!",
        signupDesc: "Create an account to get started.",
        emailPlaceholder: "Email",
        passwordPlaceholder: "Password",
        waiting: "WAITING...",
        loginBtn: "LOGIN",
        signupBtn: "SIGN UP",
        needAccount: "Need an account? Sign Up",
        hasAccount: "Already have an account? Login",
        googleLogin: "Login with Google",
        googleSignup: "Sign up with Google",

        // Add Word Modal
        editWordTitle: "Edit Word",
        addWordTitle: "Add New Word",
        suggestWordTitle: "Suggest New Word",
        wordIdSection: "Word",
        wordLabel: "Word",
        audioLabel: "Audio File (optional)",
        phoneticPlaceholder: "Pronunciation",
        meaningLabel: "Meaning",
        defPlaceholder: "Enter the definition...",
        exPlaceholder: "example sentence...",
        addMeaningBtn: "+ Add Another Meaning",
        uploading: "UPLOADING...",
        saving: "SAVING...",
        updateBtn: "UPDATE WORD",
        saveBtn: "SAVE WORD",
        submitBtn: "SUBMIT REQUEST",

        // Profile Modal
        adminProfileTitle: "Admin Profile",
        loggedInAs: "Logged in as:",
        contributionsTitle: "Your Contributions",
        noContributions: "You haven't added any words yet.",
        meaningsCount: "meaning(s)",

        // Manage Page
        backToDict: "Back to Dictionary",
        dashboardTitle: "Admin Dashboard",
        tabRequests: "Pending Requests",
        tabWords: "All Words",
        noRequests: "No pending requests.",
        noDef: "No definition provided",
        requestedBy: "Requested by:",
        approveBtn: "Approve",
        rejectBtn: "Reject",
        noWordsFound: "No words found.",

        // Parts of Speech
        partOfSpeech: {
            noun: "noun",
            verb: "verb",
            adjective: "adjective",
            adverb: "adverb",
            pronoun: "pronoun",
            preposition: "preposition",
            conjunction: "conjunction",
            interjection: "interjection",
            determiner: "determiner"
        }
    },
    tr: {
        headerTitle: "DEVRİMCİSÖZLÜk.",
        headerSubtitle: "Sözümüzün Değerine...",
        searchPlaceholder: "Bir kelime yazın...",
        searchButton: "ARA",
        palette: "Palet",
        downloadCard: "KARTI İNDİR",
        shareCard: "KARTI PAYLAŞ",
        welcomeTitle: "Hoşgeldİnİz!",
        welcomeText: "Kelime aramak için üstteki arama butonunu kullanın veya aşağıdan son eklenenlere göz atın.",
        errorTitle: "Hata",
        errorSuffix: ". Başka bir kelime deneyin.",
        noWords: "Henüz kelime yok...",
        loadMore: "Daha Fazla Yükle",
        footerText: "Hakları işçi sınıfına aittir.",

        // WordCard specific
        dictionaryEntry: "Sözcük Kartı",
        seeAlsoLabel: "Ayrıca Bakınız",
        sourceLabel: "KAYNAK",
        sourceValue: "İŞÇİ SINIFI",
        footerBrand: "DevrİmcİSözlük.",

        // Alerts
        noAudio: "Bu kelime için sesli telaffuz bulunmuyor.",
        downloadFailed: "İndirme başarısız.",
        imageGenNotReady: "Görüntü oluşturucu hazır değil.",
        imageGenFailed: "Görüntü oluşturma başarısız. Lütfen tekrar deneyin.",
        playPronunciation: "Telaffuzu dinle",

        // Navbar
        login: "Kelime Gir!",
        logout: "Çıkış",
        addWord: "Kelİme Ekle",
        suggest: "Öner",
        profile: "Profİl",
        manage: "Yönet",
        navSearch: "Ara",
        random: "Rastgele",
        searchTitle: "KELİME ARA",

        // Login Modal
        loginWelcome: "Tekrar Hoşgeldiniz",
        signupWelcome: "Kulübe Katılın",
        loginDesc: "Kelime girmek için giriş yapın!",
        signupDesc: "Başlamak için bir hesap oluşturun.",
        emailPlaceholder: "E-posta",
        passwordPlaceholder: "Şifre",
        waiting: "BEKLİYOR...",
        loginBtn: "GİRİŞ YAP",
        signupBtn: "KAYIT OL",
        needAccount: "Hesabınız yok mu? Kayıt Olun",
        hasAccount: "Hesabınız var mı? Giriş Yapın",
        googleLogin: "Google ile Giriş Yap",
        googleSignup: "Google ile Kayıt Ol",

        // Add Word Modal
        editWordTitle: "Kelimeyi Düzenle",
        addWordTitle: "Yenİ Kelİme Öner",
        suggestWordTitle: "Yeni Kelime Öner",
        wordIdSection: "Sözcük",
        wordLabel: "Sözcük",
        audioLabel: "Ses Dosyası (isteğe bağlı)",
        phoneticPlaceholder: "Okunuşu",
        meaningLabel: "Anlam",
        defPlaceholder: "Tanımı girin...",
        exPlaceholder: "örnek cümle...",
        addMeaningBtn: "+ Başka Anlam Ekle",
        uploading: "YÜKLENİYOR...",
        saving: "KAYDEDİLİYOR...",
        updateBtn: "KELİMEYİ GÜNCELLE",
        saveBtn: "KELİMEYİ KAYDET",
        submitBtn: "İSTEĞİ GÖNDER",

        // Profile Modal
        adminProfileTitle: "Admin Profili",
        loggedInAs: "Giriş yapan:",
        contributionsTitle: "Katkılarınız",
        noContributions: "Henüz hiç kelime eklemediniz.",
        meaningsCount: "anlam",

        // Manage Page
        backToDict: "Sözlüğe Dön",
        dashboardTitle: "Yönetim Paneli",
        tabRequests: "Bekleyen İstekler",
        tabWords: "Tüm Kelimeler",
        noRequests: "Bekleyen istek yok.",
        noDef: "Tanım sağlanmadı",
        requestedBy: "İsteyen:",
        approveBtn: "Onayla",
        rejectBtn: "Reddet",
        noWordsFound: "Kelime bulunamadı.",

        // Parts of Speech
        partOfSpeech: {
            noun: "İsİm",
            verb: "fİİl",
            adjective: "sıfat",
            adverb: "zarf",
            pronoun: "zamİr",
            preposition: "edat",
            conjunction: "bağlaç",
            interjection: "ünlem",
            determiner: "belİrteç"
        }
    }
};
